import sanitizeHtml from 'sanitize-html';

const defaultAllowedTags = [
  'br',
  'p',
  'span',
  'font',
  'strike',
  'strong',
  '&nbsp',
  'a',
  'em',
  'del',
  'u',
  'ul',
  'img',
  'li',
];

const defaultAllowedAttributes = {
  '*': ['style'],
  a: ['href', 'target'],
  font: ['color'],
  img: ['src', 'width', 'height'],
};

export function parseStringToHtmlAndSanitize(htmlString) {
  return {
    __html: sanitizeHtml(htmlString, {
      allowedTags: defaultAllowedTags,
      allowedAttributes: defaultAllowedAttributes,
    }),
  };
}
